import React, { memo } from "react";
import PropTypes from "prop-types";
import { SvgIcon } from "@mui/material";

const QuoteIcon = ({ className, width, height }) => {
  return (
    <SvgIcon sx={{ width: width, height: height }} className={className} viewBox="0 0 13 13" fill="none">
      <g clipPath="url(#clip0_147_1717)">
        <path
          d="M7 0H13V4.7795C13 7.11886 12.1798 9.3842 10.6822 11.1813L10 12H7L8.53669 10.0023C9.48554 8.7688 10 7.25622 10 5.7H7V0Z"
          fill="currentColor"
        />
        <path
          d="M0 0H6V4.7795C6 7.11886 5.17984 9.3842 3.68221 11.1813L3 12H0L1.53669 10.0023C2.48554 8.7688 3 7.25622 3 5.7H0V0Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_147_1717">
          <rect width="13" height="13" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
QuoteIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
QuoteIcon.defaultProps = {
  width: 13,
  height: 13,
};

export default memo(QuoteIcon);
